<div class="search-input-container">
  <mat-form-field>
    <input matInput placeholder="Search projects, jobs, components, parts, and containers..." type="text"
      [value]="searchString()" (input)="searchString.set($event.target.value)" />
    @if (searchString()) {
    <button matSuffix mat-icon-button aria-label="Clear" (click)="searchString.set('')">
      <mat-icon>close</mat-icon>
    </button>
    }
    <button matSuffix mat-icon-button aria-label="Scan a QR code or barcode" (click)="openScannerDialog()">
      <mat-icon>qr_code_scanner</mat-icon>
    </button>
  </mat-form-field>
</div>

@let searchResults = $searchResults.data(); @let projects = $safeNavigationMigration(searchResults?.projects_search);
@let jobs = $safeNavigationMigration(searchResults?.jobs_search);
@let components = $safeNavigationMigration(searchResults?.components_search); @let parts =
$safeNavigationMigration(searchResults?.parts_search);
@let containers = $safeNavigationMigration(searchResults?.containers_search);

<div class="results-container">
  <!-- Projects Card -->
  @if (projects && projects.length > 0) {
  <mat-card class="results-card">
    <mat-card-header>
      <mat-card-title>Projects ({{ projects.length }})</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <mat-list>
        @for (project of projects; track project.id) {
        @let customer = project?.customer?.shortName || project?.customerString || '';
        <mat-list-item [routerLink]="entityRoutes.project(project.id)" (click)="closeModal()">
          <img matListItemAvatar [src]="getCustomerLogoUrl(customer)" alt="{{ customer }}" />
          <div matListItemTitle>{{ project.projectNumber }}</div>
          <div matListItemLine>Last updated: {{ project.updatedAt | date }}</div>
        </mat-list-item>
        }
      </mat-list>
    </mat-card-content>
  </mat-card>
  }

  <!-- Jobs Card -->
  @if (jobs && jobs.length > 0) {
  <mat-card class="results-card">
    <mat-card-header>
      <mat-card-title>Jobs ({{ jobs.length }})</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <mat-list>
        @for (job of jobs; track job.id) {
        <mat-list-item [routerLink]="entityRoutes.job(job.id)"
          (click)="closeModal()">
          <div matListItemTitle>{{ job?.jobNumber }} | {{ job?.project?.projectNumber }} | {{ job?.project?.rig?.name }}</div>
          <div matListItemLine>Last updated: {{ job.updatedAt | date }}</div>
        </mat-list-item>
        }
      </mat-list>
    </mat-card-content>
  </mat-card>
  }

  <!-- Components Card -->
  @if (components && components.length > 0) {
  <mat-card class="results-card">
    <mat-card-header>
      <mat-card-title>Components ({{ components.length }})</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <mat-list>
        @for (component of components; track component.id) {
        <mat-list-item [routerLink]="['/components', component.serialNumber]" (click)="closeModal()">
          <part-image matListItemAvatar [partNumber]="component.assemblyNumberString || component.partNumberString"
            [width]="32" [height]="32"></part-image>
          <div matListItemTitle>
            {{ component?.serialNumber }} | {{ component?.assemblyNumberString }} | {{ component?.partNumberString }}
          </div>
          <div matListItemLine>{{ component.descriptionDeprecated }}</div>
          <div matListItemLine>Last updated: {{ component.updatedAt | date }}</div>
        </mat-list-item>
        }
      </mat-list>
    </mat-card-content>
  </mat-card>
  }

  <!-- Parts Card -->
  @if (parts && parts.length > 0) {
  <mat-card class="results-card">
    <mat-card-header>
      <mat-card-title>Parts ({{ parts.length }})</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <mat-list>
        @for (part of parts; track part.id) {
        <mat-list-item [routerLink]="['/parts', part.partNumber]" (click)="closeModal()">
          <part-image matListItemAvatar [partNumber]="part.partNumber" [width]="32" [height]="32"></part-image>
          <div matListItemTitle>{{ part?.partNumber }} | {{ part?.revision }} | {{ part?.engineeringDescription }}</div>
          <div matListItemLine>{{ part.statusString }}</div>
          <div matListItemLine>Last updated: {{ part.updatedAt | date }}</div>
        </mat-list-item>
        }
      </mat-list>
    </mat-card-content>
  </mat-card>
  }

  <!-- Containers Card -->
  @if (containers && containers.length > 0) {
  <mat-card class="results-card">
    <mat-card-header>
      <mat-card-title>Containers ({{ containers.length }})</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <mat-list>
        @for (container of containers; track container.id) {
        <mat-list-item [routerLink]="['/containers', container.containerNumber]" (click)="closeModal()">
          <div matListItemTitle>{{ container?.containerNumber }} | {{ container?.containerStatus }}</div>
          <div matListItemLine>Last updated: {{ container.updatedAt | date }}</div>
        </mat-list-item>
        }
      </mat-list>
    </mat-card-content>
  </mat-card>
  }
</div>